import React from "react"
import ReactModal from "react-modal"
import PropTypes from "prop-types"
import FontAwesome from "react-fontawesome"
import "./ModalWindow.scss"

/*
  This component can take any props defined in http://reactcommunity.org/react-modal/#usage
*/
const ModalWindow = props => {
  return (
    <ReactModal
      style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.75)" } }}
      {...props}
    >
      <div className="ModalWindow">
        <FontAwesome
          className="close"
          name="times"
          onClick={props.onRequestClose}
        />
        {props.children}
      </div>
    </ReactModal>
  )
}

ModalWindow.propTypes = {
  onRequestClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  ...ReactModal.propTypes, // http://reactcommunity.org/react-modal/#usage
}

export default ModalWindow
